import { LinkButton, LinkButtonProps } from '../Button/LinkButton'
import { ZoomOBFWarningProps } from './ZoomOBFWarning'

type ZoomOBFWarningMessageProps = ZoomOBFWarningProps & {
  onReadMore: () => void
}

export const ZoomOBFWarningMessage: React.FC<ZoomOBFWarningMessageProps> = ({ isTooltip, onReadMore }) => {
  const handleReadMore: LinkButtonProps['onClick'] = (event) => {
    event.preventDefault()
    onReadMore?.()
  }

  if (isTooltip) {
    return (
      <span className='paragraph-small text-start d-block'>
        Your AI Assistant can&apos;t join Zoom meetings without the integration connected.{' '}
        <LinkButton variant='link' to='#' onClick={handleReadMore} className='fw-bold button-link-small d-inline-block text-white text-decoration-none'>
          Read more
        </LinkButton>
      </span>
    )
  }

  return (
    <div className='bg-danger-subtle rounded-2 p-3'>
      <p className='paragraph-small zocks-text-gray-700 mb-0'>
        Your AI Assistant can&apos;t join Zoom meetings without the integration connected.{' '}
        <LinkButton variant='link' to='#' onClick={handleReadMore} className='zocks-text-primary text-decoration-none d-inline button-link-small'>
          Read more
        </LinkButton>
      </p>
    </div>
  )
}
